const ShowCollegeSection = ({ title, data }) => {
  return (
    data &&
    data?.length > 0 && (
      <div className='flex flex-col gap-8 p-4 md:px-10'>
        <h1 className='text-3xl font-bold '>{title}</h1>
        <div className='grid grid-cols-[repeat(auto-fill,_minmax(17rem,_1fr))]  w-full gap-5 gap-y-10'>
          {data?.map((d, i) => (
            <div
              key={i}
              className='grid grid-cols-1  grid-rows-[minmax(4rem,auto)_auto] grid-flow-row gap-5  h-fit w-full'
            >
              <h2 className=' font-semibold text-center '>{d?.title}</h2>

              <div
                className='h-[25rem] relative border shrink-0 snap-center group select-none bg-slate-500/30  overflow-hidden bg-cover bg-no-repeat bg-center'
                style={{
                  backgroundImage: `url(${d?.image})`
                }}
              ></div>

              {d?.info}
            </div>
          ))}
        </div>
      </div>
    )
  )
}

export default ShowCollegeSection
